import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ChatInterface from './components/ChatInterface';
import SettingsSidebar from './components/SettingsSidebar';
import DocumentsPage from './pages/DocumentsPage';
import AboutPage from './pages/AboutPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';

function App() {
  const [settings, setSettings] = useState({
    language: 'English',
    standard: 'CBSE',
    subject: 'Physics',
    method: 'Theory'
  });

  const handleSettingsChange = (newSettings) => {
    setSettings(newSettings);
  };

  return (
    <Router>
      <div className="app">
        <Navbar />
        <div className="main-content">
          <SettingsSidebar onSettingsChange={handleSettingsChange} />
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<ChatInterface settings={settings} />} />
              <Route path="/documents" element={<DocumentsPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
